import { ENV, authFetch, parseResponse, SUCCESSARRAY } from "../utils";

function cleanFilters(filters = {}) {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
}

function getAuditUrl(endpoint) {
  return `${ENV.API_URL}/${ENV.ENDPOINTS.AUDIT[endpoint]}`;
}

async function request(url) {
  const response = await authFetch(url, {
    headers: {
      Accept: "application/json",
    },
  });

  const result = await parseResponse(response);

  if (!SUCCESSARRAY.includes(response.status)) {
    throw result;
  }

  return result;
}

export class Audit {
  async recordExport(detail) {
    const response = await authFetch(getAuditUrl("EXPORT"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ detail }),
    });

    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getSessions(page = 1, limit = 20, filters = {}) {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      ...cleanFilters(filters),
    });

    const url = `${getAuditUrl("SESSIONS")}?${queryParams.toString()}`;

    return request(url);
  }

  async getLogs(page = 1, limit = 20, filters = {}) {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      ...cleanFilters(filters),
    });

    const url = `${getAuditUrl("LOGS")}?${queryParams.toString()}`;

    return request(url);
  }
}
